<template>
  <div class="input--wrap"
       :class="{'above-input': isInputAbove}">
    <div class="input-element"
         :class="{error: modelError}">
      <input autocomplete="true"
             type="text"
             :disabled="disabled"
             :id="id"
             :placeholder="placeholder"
             :name="name"
             v-model.trim="model"
             @focus="onFocus"/>
      <i v-if="model.length && !modelError"
         class="icon icon--close14"
         @click="model = ''"></i>
      <i v-if="modelError"
         class="icon icon--alert-triangle-size16"></i>
      <ui-tooltip v-show="modelError" arrowCenter>
        <span v-html="$t(`common.validationErrorText.${modelError}`)"></span>
      </ui-tooltip>
    </div>
  </div>
</template>

<script>
import UiTooltip from '@/components/ui/UiTooltip'

export default {
  components: {
    UiTooltip
  },
  props: {
    isInputAbove: {
      type: Boolean,
      default: true,
      required: false
    },
    value: {
      type: String,
      required: false
    },
    id: {
      type: String,
      required: false
    },
    placeholder: {
      type: String,
      default: 'Please enter text',
      required: false
    },
    name: {
      type: String,
      default: 'inputValue',
      required: false
    },
    modelError: {
      type: String,
      default: '',
      required: false
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  watch: {
    model (value) {
      this.$emit('input', value)
    }
  },
  data () {
    return {
      model: this.value
    }
  },
  methods: {
    onFocus () {
      this.$emit('onFocus')
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
  .input--wrap {
    width: 100%;
    position: relative;
    display: inline-block;
    text-align: left;
    margin: 0 auto;

    &.above-input {
      margin-top: 22px;
    }

    .input-element {
      position: relative;
      width: 100%;
      &.error {
        input {
          border-color: $errorColor;
        }
        .validation-text {
          color: $errorColor;
        }
      }

      input {
        display: block;
        width: 100%;
        height: 38px;
        line-height: 36px;
        border-radius: 6px;
        border: solid 1px #bbbbbb;
        background-color: #ffffff;
        font-size: 14px;
        padding-left: 12px;
        padding-right: 12px;
        box-sizing: border-box;

        &:focus {
          border-color: #289eef;
        }
        &[disabled] {
          background-color: #d7d7d7;
          opacity: 0.3;
        }
      }
    }

    .icon--close14,
    .icon--alert-triangle-size16 {
      position: absolute;
      top: calc(50% - 16px);
      right: 2px;
      padding: 9px 12px;
      cursor: pointer;
      background-position: center;
      background-color: transparent;
    }

    /deep/ .bubble {
      left: calc(100% - 23px);
      bottom: calc(100% + 10px);
      transform: translateX(-50%);
      white-space: pre;
      .text {
        @include validErrorText;
      }
    }
  }
</style>
